import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Component } from 'react';
import { getLocalText } from '@/utilities/language';
var SingleChoice = /*#__PURE__*/function (_Component) {
  _inherits(SingleChoice, _Component);
  function SingleChoice() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, SingleChoice);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SingleChoice)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var required = _this.props.question.required;
      if (required) {
        if (answer.degree === 'undefined') {
          callback(getLocalText('SingleChoice.Selected')); // '请填写答案');
          return;
        }
      }
      callback();
    });
    return _this;
  }
  _createClass(SingleChoice, [{
    key: "getDegreeChange",
    value: function getDegreeChange(degree) {
      return {
        degree: "".concat(degree),
        type: 'scale'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _marks,
        _this2 = this;
      var _this$props = this.props,
        question = _this$props.question,
        answer = _this$props.answer;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var custom = question.custom;
      var min = custom.min,
        max = custom.max,
        _custom$options = custom.options,
        options = _custom$options === void 0 ? [] : _custom$options;
      var textKey = window.showMultiLang ? "".concat(window.language, "Text") : 'text';
      // 老版量表没有options
      if (options.length === 0) {
        var _options = [];
        for (var i = min.num; i <= max.num; i++) {
          var _custom$i;
          var label = '';
          if (i === min.num) {
            label = min === null || min === void 0 ? void 0 : min[textKey];
          }
          if (i === max.num) {
            label = max === null || max === void 0 ? void 0 : max[textKey];
          }
          if ((_custom$i = custom[i]) === null || _custom$i === void 0 ? void 0 : _custom$i[textKey]) {
            var _custom$i2;
            label = (_custom$i2 = custom[i]) === null || _custom$i2 === void 0 ? void 0 : _custom$i2[textKey];
          }
          _options.push({
            text: label,
            num: i,
            id: i,
            jumpId: '-1'
          });
        }
      }
      var marks = (_marks = {}, _defineProperty(_marks, min.num, min.num), _defineProperty(_marks, max.num, max.num), _marks);
      for (var _i = min.num; _i <= max.num; _i++) {
        var _custom$_i;
        marks[_i] = ((_custom$_i = custom[_i]) === null || _custom$_i === void 0 ? void 0 : _custom$_i[textKey]) || '';
      }
      var degree = answer.degree;
      var id = question.id || 'unknown-form-item';
      var _getFieldProps = getFieldProps(id, {
          initialValue: _objectSpread({}, answer, {
            degree: "".concat(degree)
          }),
          rules: [{
            required: true,
            validator: this.validator
          }]
        }),
        _onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value;
      var error = getFieldError(id);
      if (error && error.length > 0) error = error.join(',');else error = null;
      var params = {
        error: error,
        formAnswer: formAnswer,
        onChange: function onChange(val) {
          return _onChange(_this2.getDegreeChange(+val));
        },
        marks: marks,
        options: options,
        max: max,
        min: min
      };
      return this.props.children(params);
    }
  }]);
  return SingleChoice;
}(Component);
_defineProperty(SingleChoice, "defaultProps", {
  answer: {
    degree: undefined,
    type: 'scale'
  }
});
export { SingleChoice as default };